import { createGrid } from 'ag-grid-community';
import { plainText, urlRenderer, fitGridHeight } from './sequence_grid_helpers.js';

$(document).ready(function() {
  if ($('body').data('controller') === 'sequences' && $('body').data('action') === 'limited') {
    const eGridDiv = document.querySelector('#myGridLimited');
    const sequencesDataElement = document.getElementById('sequences-data');
    if (!eGridDiv || !sequencesDataElement) return;

    const rowData = JSON.parse(sequencesDataElement.dataset.json);

    const columnDefs = [
      { headerName: 'Texts', field: 'sequence_text', minWidth: 190, flex: 1.25, cellRenderer: plainText },
      { headerName: 'Creations', field: 'sequence_creation', minWidth: 160, flex: 1, cellRenderer: plainText },
      { headerName: 'Completes', field: 'sequence_complete', minWidth: 160, flex: 1, cellRenderer: plainText },
      { headerName: 'Lexigrams', field: 'sequence_lexigram', minWidth: 160, flex: 1, cellRenderer: plainText },
      { headerName: 'Singulars', field: 'sequence_singular', minWidth: 160, flex: 1, cellRenderer: plainText },
      { headerName: 'Lenses', field: 'sequence_lense', minWidth: 160, flex: 1, cellRenderer: plainText },
      { headerName: 'Description', field: 'description', minWidth: 240, flex: 1.5, cellRenderer: plainText },
      { headerName: 'Url', field: 'url', minWidth: 220, flex: 1.2, cellRenderer: urlRenderer },
      { headerName: 'Reference', field: 'reference', minWidth: 260, flex: 1.5, cellRenderer: plainText },
    ];

    const gridOptions = {
      columnDefs: columnDefs,
      rowData: rowData,
      defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
        suppressMovable: true
      },
      rowHeight: 44,
      suppressMovableColumns: true,
      suppressDragLeaveHidesColumns: true,
      ensureDomOrder: true
    };

    fitGridHeight(eGridDiv, rowData.length, { rowHeight: 44, max: 740 });
    createGrid(eGridDiv, gridOptions);
  }
});
